import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Operator } from '../../types/operators';

export interface OperatorsState {
  operators: Operator[];
  loading: boolean;
  error: string | null;
}

const initialState: OperatorsState = {
  operators: [],
  loading: false,
  error: null,
};

export const generateOperatorAsync = createAsyncThunk(
  'operators/generateOperator',
  async () => {
    // Implement the logic to generate a new operator
    // This is just a placeholder, replace with actual logic
    const newOperator: Operator = {
      id: Date.now().toString(),
      name: `Operator ${Date.now()}`,
      specialization: "combat", // Changed from 'General' to a valid specialization
      personalityTraits: ['Adaptable'],
      isFavorite: false,
      attributes: {
        strength: 5,
        dexterity: 5,
        intelligence: 5,
        constitution: 5,
        agility: 5,
        endurance: 5,
        reflexes: 5,
        kinestheticSense: 5,
        recuperation: 5,
        finesse: 5,
        wisdom: 5,
        luck: 5,
      },
      skills: {
        combat: 1,
        technology: 1,
        survival: 1,
        research: 1,
        engineering: 1,
      },
    };
    return newOperator;
  }
);

const operatorSlice = createSlice({
  name: 'operators',
  initialState,
  reducers: {
    addOperator: (state, action: PayloadAction<Operator>) => {
      state.operators.push(action.payload);
    },
    // Add other reducers as needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateOperatorAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateOperatorAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.operators.push(action.payload);
      })
      .addCase(generateOperatorAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to generate operator';
      });
  },
});

export const { addOperator } = operatorSlice.actions;
export default operatorSlice.reducer;